export default theme => ({
  dialogContent: {
    display: 'flex',
    flexDirection: 'column'
  },
  link: {
    color: theme.palette.secondary.main
  }
});
